import { render, staticRenderFns } from "./TestView.vue?vue&type=template&id=73469b67&"
import script from "./TestView.vue?vue&type=script&lang=ts&"
export * from "./TestView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports